import { Features } from '../../constants/features';
import { useIsSellerFeatureEnabled } from '../../hooks/use-is-seller-feature-enabled';
import { usePackingRecommendationEnforcementModeSetting } from '../../hooks/use-seller-setting';
import { PackingEnforcementMode } from './constants';

// Falls back to Advisory (no gating) when packing recommendations aren't enabled for the seller.
export const usePackingEnforcementMode = (): PackingEnforcementMode => {
  const isPackingRecommendationEnabled = useIsSellerFeatureEnabled(Features.PackingRecommendations);
  const settingMode = usePackingRecommendationEnforcementModeSetting();

  return isPackingRecommendationEnabled ? settingMode : PackingEnforcementMode.Advisory;
};
